import React, {useState, useEffect} from 'react';
// import Container from 'react-bootstrap/Container';
import {runQuery} from '../utils'
import {getPossibleMatches} from './queries'

interface MyComponentProps {
  searchString: string
  handleChangeInfo?: any,
}

export const ResourceSuggestor: React.FC<MyComponentProps> = (props) => {
  const [resources, setResources] = useState<any[]>([])

  const update = () => {
    // console.log("firing")
    runQuery(getPossibleMatches(props.searchString)).then((data: any) => {
      // console.log("data", data)
      const results = data.data.results.bindings.map((i: any) => {
        // console.log("i", i)
        return {
          id: i.resource.value,
          title: i.resourceTitle.value,
          author: i.author ? i.author.value : null,
          authorTitle: i.authorTitle ? i.authorTitle.value : null, 
        }
      })
      setResources(results)
    })
  }
  useEffect(() => {
   update()
  },[props.searchString])

  return (
    resources.map((r) => {
      return (
        <p key={r.id}>
          <span className="lbp-span-link" onClick={() => props.handleChangeInfo(r.id)}>
            {r.author ? r.authorTitle + ": " : ""} {r.title}
          </span>
        </p>
      )
    }
  )
)
}